import { Grid, Typography } from "@mui/material";

export const SettingsLabel = ({ info }) => {
    return (
        <Grid item display="flex" alignItems={"center"}  minHeight='40px' xs={3.8}  >
            <Typography variant="h5" sx={{ paddingRight: "10px" }} >
                {info}
            </Typography>
        </Grid>
    )
}
export default SettingsLabel;